let lightDotsCreated = false;

/* ====================================
# 光の点エフェクト
==================================== */
export const addLightDots = (container) => {
  // グローバルな重複防止チェック
  if (lightDotsCreated) {
    return;
  }

  const svgElement = container.querySelector('svg');
  if (!svgElement) return;

  // 既に光の点が追加されているかチェック（全体から）
  const existingDots = document.querySelectorAll('.light-dot');
  if (existingDots.length > 0) {
    return; // 既に光の点がある場合は何もしない
  }

  // 光の点作成フラグを立てる
  lightDotsCreated = true;

  // opacity=0.5のグループ内のpath要素を探す
  const borderGroup = svgElement.querySelector('g[opacity="0.5"]');
  if (!borderGroup) {
    // opacity=0.5のグループが見つからない場合、全てのpath要素を確認
    const allPaths = svgElement.querySelectorAll('path[stroke]');
    if (allPaths.length > 0) {
      createLightDot(allPaths[0], container);
      return;
    }
    return;
  }

  const borderPath = borderGroup.querySelector('path[stroke]');
  if (!borderPath) return;

  // 1つの光の点を作成
  createLightDot(borderPath, container);
};

const createLightDot = (pathElement, container) => {
  // 光の点要素を作成
  const lightDot = document.createElement('div');
  lightDot.className = 'light-dot';
  lightDot.style.cssText = `
    position: absolute;
    width: 30px;
    height: 30px;
    background: rgba(255, 255, 255, 0.95);
    filter: blur(10px);
    border-radius: 50%;
    pointer-events: none;
    z-index: 10;
    transform: translate(-50%, -50%);
  `;

  // コンテナに追加
  container.appendChild(lightDot);

  // パスの長さを取得
  const pathLength = pathElement.getTotalLength();
  let currentDistance = 0;
  let isAnimating = true;

  // SVGの変換行列を取得
  const getTransformMatrix = (element) => {
    const transform = element.getAttribute('transform') || '';
    const matrixMatch = transform.match(/matrix\(([^)]+)\)/);
    if (matrixMatch) {
      const values = matrixMatch[1].split(',').map(v => parseFloat(v.trim()));
      return {
        a: values[0] || 1, b: values[1] || 0, c: values[2] || 0,
        d: values[3] || 1, e: values[4] || 0, f: values[5] || 0
      };
    }
    return { a: 1, b: 0, c: 0, d: 1, e: 0, f: 0 };
  };

  // アニメーションループ
  const animateLightDot = () => {
    if (!isAnimating) return;

    // パス上の現在位置を取得
    const point = pathElement.getPointAtLength(currentDistance);

    // SVGの世界座標系への変換を簡潔にする
    const svgElement = pathElement.closest('svg');
    const svgCTM = pathElement.getScreenCTM();

    if (svgCTM) {
      // SVGの変換行列を使って正確な画面座標を取得
      const screenPoint = point.matrixTransform(svgCTM);

      // コンテナの位置を考慮
      const containerRect = container.getBoundingClientRect();

      // 相対位置に変換
      const dotX = screenPoint.x - containerRect.left;
      const dotY = screenPoint.y - containerRect.top;

      lightDot.style.left = dotX + 'px';
      lightDot.style.top = dotY + 'px';

    } else {

      // 親グループの変換行列を取得
      const groupTransform = getTransformMatrix(pathElement.closest('g'));
      const outerGroupTransform = getTransformMatrix(pathElement.closest('g').parentElement);

      // 変換を適用
      let x = point.x;
      let y = point.y;

      // 内側のグループ変換を適用
      const transformedX = groupTransform.a * x + groupTransform.c * y + groupTransform.e;
      const transformedY = groupTransform.b * x + groupTransform.d * y + groupTransform.f;

      // 外側のグループ変換を適用
      const finalX = outerGroupTransform.a * transformedX + outerGroupTransform.c * transformedY + outerGroupTransform.e;
      const finalY = outerGroupTransform.b * transformedX + outerGroupTransform.d * transformedY + outerGroupTransform.f;

      // SVGのビューポートを考慮
      const containerRect = container.getBoundingClientRect();
      const svgRect = svgElement.getBoundingClientRect();

      // 最終位置を設定
      const dotX = finalX + (svgRect.width / 2);
      const dotY = finalY + (svgRect.height / 2);

      lightDot.style.left = dotX + 'px';
      lightDot.style.top = dotY + 'px';
    }

    // 次の位置に移動（左回り）
    currentDistance -= 8; // 移動速度
    if (currentDistance < 0) {
      currentDistance = pathLength; // 一周したら最後に戻る
    }

    requestAnimationFrame(animateLightDot);
  };

  animateLightDot();
};